export default __webpack_public_path__ + "static/media/fisiatria.157ff777.jpg";